import { Autocomplete, TextField } from '@mui/material';
import {
  CustomAttributeOption,
  CustomAttributeValue,
} from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getAttributeOptionByKey,
  getKindLikeValueSafely,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';

export const DropdownEditor = ({
  value,
  definition,
  onChange,
  onSave,
  onCancel,
  disabled,
}: CustomAttributeEditProps) => {
  const selected = getKindLikeValueSafely(value, 'dropdown');
  const { options } = definition;

  const selectedOption = selected
    ? (getAttributeOptionByKey(options, selected) ?? null)
    : null;

  return (
    <Autocomplete<CustomAttributeOption>
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option.value}
      isOptionEqualToValue={(a, b) => a.key === b.key}
      onChange={(_event, next) => {
        const value: CustomAttributeValue = { kind: 'dropdown', value: next?.key ?? null };
        onChange(value);
        onSave(value);
      }}
      onClose={(_event, reason) => {
        if (reason === 'escape' || reason === 'blur') onCancel();
      }}
      disabled={disabled}
      size="small"
      fullWidth
      autoHighlight
      openOnFocus
      forcePopupIcon={false}
      sx={(theme) => ({
        '& .MuiOutlinedInput-root': {
          padding: 0,
          '& fieldset': { border: 0 },
          '&.Mui-focused fieldset': { border: 0 },
          '&:hover fieldset': { border: 0 },
        },
        '& .MuiAutocomplete-input': {
          padding: theme.spacing(0.25, 0.5),
          fontSize: '0.8rem',
        },
      })}
      renderInput={(params) => (
        <TextField {...params} size="small" autoFocus autoComplete="off" />
      )}
    />
  );
};
